import React, { useEffect, useState } from "react";
import DeleteButton from "../Buttons/DeleteButton";
import EditButton from "../Buttons/EditButton";
import DateAndTimeChip from "../Chips/DateAndTimeChip";
import SmallClientChip from "../SmallClientChip";
import { Box, Modal } from "@mui/material";
import EditFamilyNote from "./EditFamilyNote";
import DeleteFamilyNote from "./DeleteFamilyNote";
import ViewFamilyNote from "./ViewFamilyNote";
import TypeNoteChip from "../Chips/TypeNoteChip";
import { useNavigate } from "react-router-dom";
import "./FamilyNoteContainerRedesign.css";

function FamilyNoteContainer(props) {
  const styleEdit = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "min(900px, calc(100vw - 32px))",
    maxHeight: "88vh",
    borderRadius: 3,
    backgroundColor: "white",
    boxShadow: 24,
    overflow: "hidden",
  };

  const styleView = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 750,
    height: "auto",
    borderRadius: 5,
    backgroundColor: "white",
    boxShadow: 24,
  };

  const styleDeleteModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 300,
    height: 260,
    borderRadius: 2,
    bgcolor: "background.paper",
    boxShadow: 24,
  };

  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [shouldNavigate, setShouldNavigate] = useState(false);
  const navigate = useNavigate();

  const openEditModal = () => setShowEditModal(true);
  const openDeleteModal = () => setShowDeleteModal(true);
  const closeEditModal = () => setShowEditModal(false);
  const closeDeleteModal = () => setShowDeleteModal(false);
  const closeViewModal = () => setShowViewModal(false);
  const handleNavigate = () => setShouldNavigate(true);

  const relationship =
    props.relationship === "Other"
      ? props.relationshipOther || "Other"
      : props.relationship || "-";

  useEffect(() => {
    if (shouldNavigate) {
      navigate(`/client/${props.clientId}`, { state: props });
    }
  }, [shouldNavigate]);

  return (
    <div className="notes-wrapper">
      <Modal
        open={showEditModal}
        onClose={closeEditModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleEdit}>
          <EditFamilyNote
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeEditModal}
            fileLinks={props.fileUrls}
            relationshipFamilyNote={props.relationship}
          />
        </Box>
      </Modal>

      <Modal
        open={showDeleteModal}
        onClose={closeDeleteModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleDeleteModal}>
          <DeleteFamilyNote
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeDeleteModal}
          />
        </Box>
      </Modal>

      <Modal
        open={showViewModal}
        onClose={closeViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleView}>
          <ViewFamilyNote
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeViewModal}
            relationshipFamilyNote={props.relationship}
            fileUrls={props.fileUrls}
          />
        </Box>
      </Modal>

      <article className="family-note-summary-card">
        <div className="family-note-summary-top">
          <div className="family-note-summary-chips">
            <DateAndTimeChip date={props.noteDate} />
            <DateAndTimeChip date={props.noteTime} />
            <TypeNoteChip noteType={props.noteType} />
          </div>

          <div className="family-note-summary-actions">
            <EditButton handleOpen={openEditModal} />
            <DeleteButton handleOpen={openDeleteModal} />
          </div>
        </div>

        <div className="family-note-summary-main">
          <button
            type="button"
            className="family-note-client-button"
            onClick={handleNavigate}
          >
            <SmallClientChip
              firstName={props.clientFirstName}
              lastName={props.clientLastName}
              avatar="1"
              clientPic={props.clientPic}
            />
          </button>

          <div className="family-note-summary-meta">
            <div className="family-note-summary-meta-item">
              <span>Done by</span>
              <strong>{props.doneBy || "-"}</strong>
            </div>
            <div className="family-note-summary-meta-item">
              <span>Created</span>
              <strong>{props.timeStamp || "-"}</strong>
            </div>
            <div className="family-note-summary-meta-item">
              <span>Relationship</span>
              <strong>{relationship}</strong>
            </div>
            <div className="family-note-summary-meta-item">
              <span>Attachments</span>
              <strong>{props.fileUrls?.length || 0}</strong>
            </div>
          </div>
        </div>

        <div className="family-note-summary-secondary">
          <div className="family-note-summary-meta-item">
            <span>Last modification</span>
            <strong>{props.lastModification || "-"}</strong>
          </div>
          <div className="family-note-summary-meta-item family-note-files">
            <span>Files</span>
            <strong>
              {props.fileUrls?.length
                ? props.fileUrls.map((file, index) => (
                    <React.Fragment key={`${file.url || file.name}-${index}`}>
                      {index > 0 && ", "}
                      <a href={file.url} target="_blank" rel="noreferrer">
                        {file.name || "File"}
                      </a>
                    </React.Fragment>
                  ))
                : "No files attached"}
            </strong>
          </div>
        </div>

        <div className="family-note-summary-content">
          {props.noteContent || "No note content."}
        </div>
      </article>
    </div>
  );
}

export default FamilyNoteContainer;
